import {
    FETCH_NOTIFICATION_SUCCESS,
    FETCH_NOTIFICATION_ERROR,
    FETCH_NOTIFICATION_LOADING,
    FETCH_ALL_NOTIFICATION_SUCCESS
} from "./index" 

import {apiCall} from "../../functions/utils"

export const fetchNotificationSuccess = (data) => {
    return {
        type : FETCH_NOTIFICATION_SUCCESS,
        payload: data.notifications
    }
}

export const fetchAllNotificationSuccess = (data) => {
    return {
        type : FETCH_ALL_NOTIFICATION_SUCCESS,
        payload: data
    }
}

export const fetchNotificationError = (error) => {
    return {
        type : FETCH_NOTIFICATION_ERROR,
        error
    }
}

export const fetchNotificationLoading = () => {
    return {
        type : FETCH_NOTIFICATION_LOADING
    }
}

export const fetchNotifications = (query = "", page = 1) => {
    return async (dispatch, getState) => {
        dispatch(fetchNotificationLoading())
        try{
            const res = await apiCall(true, "GET", `/api/notifications`)
            dispatch(fetchNotificationSuccess(res.data))
        }catch(e){
            dispatch(fetchNotificationError(e))
        } 
    }
}

export const fetchAllNotifications = () => {
    return async (dispatch, getState) => {
       let accounts = getState().authUser.user?.accounts
       let data = []
       let promises = [];
       if( accounts ){
        accounts.forEach(account => {
            promises.push( apiCall(true, "GET", `/api/notifications`, {}, true, true, false, account.id) );
        });
        Promise.all(promises).then( function (results) {
            results.forEach( (res,key) => {
                if( res?.data?.notifications ){
                    data[key] = res.data.notifications
                }else{
                    data[key] = []
                }
            } );
            dispatch(fetchAllNotificationSuccess(data));
        });
       }
    }
}